.loopLabel {
  user-select: none;
}
